import { Image, type ImageProps } from "@chakra-ui/react";
import * as React from "react";

import { assetUrl, brand } from "../lib/brand";

export interface LogoProps extends Omit<ImageProps, "src"> {}

export const Logo = (props: LogoProps) => (
  <Image
    alt={brand.productName}
    fit="scale-down"
    src={assetUrl("logo.png")}
    {...props}
  />
);
